import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { usePolicyContext } from "../../Contexts/AddPolicyContext";
import { useEffect } from "react";
import { resetConfig } from "../../utilities/helper";

function ChooseMembership() {
  const { setSelectedType, navigate, handleBack } = usePolicyContext();

  useEffect(() => {
    resetConfig();
  }, []);

  const handleNext = (e) => {
    setSelectedType(e.currentTarget.id);
    navigate(`/add-policy/card-number`);
  };
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" || event.key === " ") {
      callback();
    }
  };
  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center cursor-default">
      <div className="w-full sm:w-148 flex-grow">
        <div className="sm:w-full h-78 bg-white rounded-xl sm:mt-24">
          <div className="grid grid-cols-1 divide-y">
            <div className="flex flex-row p-3">
              <KeyboardArrowLeftIcon
                className="cursor-pointer"
                onClick={handleBack}
              />
              <div className="text-center text-md font-bold flex-grow">
                Add Policy
              </div>
            </div>

            <div className="p-4">
              <div>
                <div className="font-bold text-2xl text-[#1F2328]">
                  Select how you'd like to add your policy
                </div>

                <div className="text-[#60656D] mt-2">
                  Choose from the options below to add your policy
                </div>
              </div>

              <div className="flex flex-col items-center justify-center mt-4">
                <button
                  id="Personal"
                  className="w-full sm:w-full transition text-start ease-in-out delay-75 hover:scale-105 border border-[#E3E4E5] rounded-md p-2 cursor-pointer"
                  onClick={handleNext}
                  onKeyDown={(event) =>
                    handleKeyDown(event, () => handleNext(event))
                  }
                >
                  <div className="flex flex-row ">
                    <img
                      src={require("../../assets/maxicare.png")}
                      alt="Personal"
                      className="w-10 h-10"
                    />
                    <div className="flex flex-col justify-center mt-1 ml-2">
                      <p className="font-semibold">Maxicare Card</p>
                      <p className=" text-[#60656D] mt-1">
                        Optimize your well-being with Maxicare HMO.
                      </p>
                    </div>
                  </div>
                </button>
                <button
                  id="Corporate"
                  className="w-full sm:w-full transition text-start ease-in-out delay-75 hover:scale-105 border border-[#E3E4E5] rounded-md my-3 p-2 cursor-pointer mt-6"
                  onClick={handleNext}
                  onKeyDown={(event) =>
                    handleKeyDown(event, () => handleNext(event))
                  }
                >
                  <div className="flex flex-row">
                    <img
                      src={require("../../assets/corporate.png")}
                      alt="Corporate"
                      className="w-10 h-10"
                    />
                    <div className="flex flex-col justify-center mt-1 ml-2">
                      <p className="font-semibold">
                        Employee ID and corporate code
                      </p>
                      <p className="text-[#60656D] mt-1">
                        Prioritize health with your employer-provided Corporate
                        Membership for a healthy workforce.
                      </p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChooseMembership;
